import { Component, Inject, Input, OnChanges } from '@angular/core';
import { LibConfig } from '../../models/lib-config.model';
import { LIB_CONFIG } from '../../lib-config';
import { ButtonTarget } from '@challenger6/vm-pattern-library/button';
//import { AnalyticsHelperService } from '../../services/analytics.helper.service';
// import { AnalyticsService } from '@challenger/shared/services/analytics.service';
import { AnalyticsService } from '../../services/analytics.service';
import { HelpArticlesService } from '../../services/help-articles.service';
// import { HelpArticlesService } from '@challenger/care-deprecated/shared/services/help-articles.service';
import { AnimationOptions } from 'ngx-lottie';
// import { Article } from '@challenger/core/modules/graphql/generated/graphql-types';
/* eslint-disable @typescript-eslint/naming-convention */

@Component({
  selector: 'vm-did-this-help',
  templateUrl: './did-this-help.component.html',
  styleUrls: ['./did-this-help.component.scss'],
})
export class DidThisHelpComponent implements OnChanges {
  @Input() initialTilesShownCount: number;
  @Input() articleId = 'angular-did-this-help';
  @Input() liveChatTagId = 'faultsbuttonnew';
  @Input() category = 'faults';
  @Input() showOpeningHours = true;

  didWorkSelected = false;
  didWork: boolean;
  strapiUrl: string;
  thumbsUpImageOption: AnimationOptions;
  supportOptions: any;
  referFriendContent: any;

  yesButtonImageContent = {
    optionHeader: '',
    optionSubHeader: '',
    buttonText: '',
    buttonLink: '',
    buttonTarget: ButtonTarget._self,
    imageLink: '',
  };

  constructor(
    @Inject(LIB_CONFIG) private config: LibConfig,
    private analyticsService: AnalyticsService,
    private helparticleService: HelpArticlesService
  ) {
    this.strapiUrl = this.config.strapiURL;
  }

  ngOnChanges(): void {
    this.helparticleService.getArticle(this.articleId).subscribe((article: any) => {
      this.supportOptions = this.helparticleService.getSupportOptionElement(article);
      this.thumbsUpImageOption = {
        path: this.strapiUrl + this.supportOptions?.media[0]?.media[0]?.url,
        loop: false,
      };
      const referFriendElement = this.helparticleService.getGlobalComponentElement(article, 'refer-friend');
      const referAFriendContent = this.helparticleService.getGenericComponent(
        referFriendElement,
        'yes-button-refer-friend'
      );
      this.yesButtonImageContent = {
        optionHeader: referAFriendContent?.title,
        optionSubHeader: referAFriendContent?.subtitle,
        buttonText: referAFriendContent?.ctas[0]?.label,
        buttonLink: referAFriendContent?.ctas[0]?.url,
        imageLink: this.strapiUrl + referAFriendContent?.icon[0].url,
        buttonTarget: referAFriendContent?.ctas[0]?.targetNewPage ? ButtonTarget._blank : ButtonTarget._self,
      };
    });
  }

  getYesNoCtaContent() {
    return {
      headingText: this.supportOptions?.mainHeading,
      yesButtonText: this.supportOptions?.hyperlink[0]?.label,
      noButtonText: this.supportOptions?.hyperlink[1]?.label,
    };
  }

  onHasHelpedSelected(val: boolean) {
    this.didWork = val;
    this.didWorkSelected = true;
    const ctaContent = this.getYesNoCtaContent();
    const ctaLabel = this.didWork ? ctaContent.yesButtonText : ctaContent.noButtonText;
    const btnClickEvent = {
      event: 'feedback',
      event_name: 'online_support_feedback',
      event_params: {
        support_category: this.category,
        content_text: ctaLabel,
        content_type: `web - ${this.category} - csat ${ctaLabel?.toLocaleLowerCase()}`,
      },
    };
    this.analyticsService.addDataLayer('feedback', btnClickEvent);
  }

  supportOptionSelected(supportTile: any) {
    const supportClickEvent = {
      event: 'content_actions',
      event_name: 'content_clicked',
      event_params: {
        content_type: `web - ${this.category} - alternative support options`,
        content_link: supportTile?.href,
        content_name: supportTile?.heading,
      },
    };
    this.analyticsService.addDataLayer('content_actions', supportClickEvent);
  }
}
